import { ReadonlyRepositoryListService, Result } from '@softline/core';
import { computed, inject, Injectable, INJECTOR } from '@angular/core';
import {
  LieferantenDokumenteQuery,
  LieferantenDokumenteRepository,
} from '../repositories/lieferanten-dokumente.repository';
import { Document } from '../types/document';
import { SupplierIdService } from './supplier-id.service';
import { handleRequestError } from '@softline/application';
import { MessageBarService } from '@softline/ui-core';

@Injectable()
export class LieferantenDokumenteService extends ReadonlyRepositoryListService<
  Document,
  Result<Document[]>,
  LieferantenDokumenteQuery
> {
  readonly #injector = inject(INJECTOR);
  readonly #messageBarService = inject(MessageBarService);
  readonly #dokumentRepo = inject(LieferantenDokumenteRepository);
  readonly #supplierIdService = inject(SupplierIdService);

  idktostamm = computed(() => this.#supplierIdService.supplierId()());

  override params = computed(() => {
    return { idktostamm: this.idktostamm() };
  });

  constructor() {
    super(inject(LieferantenDokumenteRepository));
  }

  protected override getItems(result: Result<Document[]> | null | undefined): Document[] {
    return result?.result as Document[];
  }

  setUpdatedList(result: Document[]): void {
    this.all.set(result);
  }

  async editFileName(doc: Document, name: string) {
    try {
      await this.#dokumentRepo.updateDoc(doc, name);

      const items = [...this.value()];
      const index = items.findIndex(
        (o) => o.dokument.documentKey === doc.dokument.documentKey
      );

      if (index < 0) {
        return;
      }

      items[index] = {
        ...doc,
        dokument: {
          ...doc.dokument,
          dokumentname: name,
        },
      };
      this.setUpdatedList(items);
      this.#messageBarService.success('Dokument wurde Erfolgreich umbenennt.');
    } catch (error) {
      handleRequestError(error, this.#injector, { show: true });
    }
  }

  async deleteFile(doc: Document) {
    try {
      await this.#dokumentRepo.deleteFile(doc);

      this.#messageBarService.success('Dokument wurde Erfolgreich entfernt.');
    } catch (error) {
      handleRequestError(error, this.#injector, { show: true });
    }
  }
}
